import axios from "axios";
import React, { useEffect, useState } from "react";
import SMPdfMaster from "../StationMapPdf/SMPdfMaster";
import SMPDFSWR from "../StationMapPdf/SMPDFSWR";
import SMPDFPassengerAmt from "../StationMapPdf/SMPDFPassengerAmt";
import { MdNearbyError } from "react-icons/md";

const StationDetails = ({ activeStation, data, sec }) => {
  const head = ["SR.", "DESIGNATION", "GRADE PAY", "SS", "OR", "VC"];
  const head1 = ["SR.", "NAME", "CATEGORY", "LENGTH"];
  const head2 = ["SR.", "DESIGNATION", "NAME", "GRADE PAY"];
  return (
    <div className="">
      {activeStation && (
        <h5 className="p-2 rounded  card-header-soft">{activeStation}</h5>
      )}
      {data.station_details?.length > 0 ? (
        <div className="row" style={{ fontSize: "13px" }}>
          <div className="col-md-8 row">
            {" "}
            {/* ////////////////////////station code///////////////////////////////// */}
            {data.station_details?.length > 0 && (
              <div className="col-md-4 mt-3">
                <div
                  className="shadow-sm mb-4 glass-card"
                  style={{
                    borderRadius: "100px",
                    padding: "18px 22px",
                  }}
                >
                  {data.station_code?.map((o, i) => (
                    <div className="d-flex justify-content-between align-items-center mb-1">
                      <span
                        className="px-4 py-2 fw-bold card-header-soft"
                        style={{
                          borderRadius: "999px",
                        }}
                      >
                        {o.station}
                      </span>{" "}
                    </div>
                  ))}
                  {data.station_code?.map((o, i) => (
                    <div key={i} className="small text-center">
                      <div className="mb-2">
                        <div className="text-muted">SECTION</div>
                        <strong>{o.section}</strong>
                      </div>

                      <div className="mb-2">
                        <div className="text-muted">DISTANCE</div>
                        <strong>{o.distance_from_cstm_km || "—"} km</strong>
                      </div>

                      <div className="mb-2">
                        <div className="text-muted">CLASS</div>
                        <strong>{o.station_class || "—"}</strong>
                      </div>
                    </div>
                  ))}{" "}
                  {data.station_details?.map((o, i) => (
                    <div key={i} className="small text-center">
                      {" "}
                      <div>
                        <div className="text-muted mb-2">
                          SYSTEM OF WORKING{" "}
                        </div>
                        <strong>{o.system_of_working || "—"}</strong>
                      </div>
                      <div className="mb-2">
                        <div className="text-muted">SIGNAL TYPE</div>
                        <strong>{o.signalling_type || "—"}</strong>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {/* ////////////////////////station officers///////////////////////////////// */}
            {data.station_officers?.length > 0 && (
              <div className="col-md-8 mt-5">
                <div
                  className="shadow-sm mb-4 glass-card"
                  style={{
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="card-header-soft"
                    style={{
                      clipPath: "polygon(0 0, 100% 0, 100% 50%, 0 100%)",
                    }}
                  >
                    <strong>OFFICERS</strong>
                  </div>

                  <div className="p-2 fw-semibold table-responsive">
                    <table className="text-start">
                      <thead>
                        <tr>
                          {head2.map((o, i) => (
                            <th key={i}>{o}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {" "}
                        {data.station_officers?.map((o, i) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>{o.role}</td>
                            <td>{o.officer_name}</td> <td>{o.grade_pay}</td>
                            <td>{o.on_roll}</td> <td>{o.vacancy}</td>{" "}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            {/* ////////////////////////STAFF STRENGTH///////////////////////////////// */}
            {data.station_staff_strength?.length > 0 && (
              <div className="col-md-6 mt-3">
                <div
                  className="shadow-sm mb-4 glass-card"
                  style={{
                    borderRadius: "18px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="card-header-soft"
                    style={{
                      padding: "12px",
                      clipPath: "polygon(0 0, 100% 0, 100% 50%, 0 100%)",
                    }}
                  >
                    <strong>STAFF STRENGTH</strong>
                  </div>

                  <div className="p-2 fw-semibold table-responsive">
                    <table className="text-start">
                      <thead>
                        <tr>
                          {head.map((o, i) => (
                            <th key={i}>{o}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {" "}
                        {data.station_staff_strength?.map((o, i) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>{o.designation}</td>
                            <td>{o.grade_pay}</td>{" "}
                            <td>{o.sanctioned_strength}</td>
                            <td>{o.on_roll}</td> <td>{o.vacancy}</td>{" "}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            {/* ////////////////////////STAFF STRENGTH///////////////////////////////// */}
            {data.station_staff_strength?.length > 0 && (
              <div className="col-md-6 mt-3">
                <div
                  className="shadow-sm mb-4 glass-card"
                  style={{
                    borderRadius: "18px",
                    overflow: "hidden",
                  }}
                >
                  <div
                    className="card-header-soft"
                    style={{
                      padding: "12px",
                      clipPath: "polygon(0 0, 100% 0, 100% 50%, 0 100%)",
                    }}
                  >
                    <strong>STAFF STRENGTH</strong>
                  </div>

                  <div className="p-2 fw-semibold table-responsive">
                    <table className="text-start">
                      <thead>
                        <tr>
                          {head.map((o, i) => (
                            <th key={i}>{o}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {" "}
                        {data.station_staff_strength?.map((o, i) => (
                          <tr>
                            <td>{i + 1}</td>
                            <td>{o.designation}</td>
                            <td>{o.grade_pay}</td>{" "}
                            <td>{o.sanctioned_strength}</td>
                            <td>{o.on_roll}</td> <td>{o.vacancy}</td>{" "}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
            {/* ///////////////////////work///////////////////////////////// */}
            {data.station_special_works?.length > 0 && (
              <div className="col-md-12 ">
                <div>
                  {data.station_special_works && (
                    <div
                      className="p-2 rounded mb-1 text-white card-header-soft"
                      style={{
                        borderRadius: "18px",
                        paddingLeft: "12px",
                        overflow: "hidden",
                      }}
                    >
                      <table className="">
                        <tbody>
                          <td>SR.</td>
                          <td>WORK DISCRIPTION</td>
                          <td>STATUS</td>
                        </tbody>
                      </table>
                    </div>
                  )}

                  {data.station_special_works?.map((o, i) => (
                    <div
                      key={i}
                      className="position-relative shadow-sm mb-1 glass-card"
                      style={{
                        borderRadius: "18px",
                        paddingLeft: "12px",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          left: 0,
                          top: 0,
                          bottom: 0,
                          width: "8px",
                          backgroundColor: "#635656ff",
                        }}
                      />

                      <div className="p-2 fw-semibold table-responsive">
                        <table>
                          <tbody>
                            <td>{i + 1}</td>
                            <td>{o.work_description}</td>
                            <td>{o.work_status}</td>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>{" "}
          {/* ////////////////////////layout///////////////////////////////// */}
          <div className="col-md-4 mt-3">
            <div className="shadow-sm rounded mb-4 ">
              <div className="card-header-soft">
                <strong>PDF</strong>
              </div>
              <div className="d-flex justify-content-around overflow-auto">
                <div>
                  <SMPdfMaster activeStation={activeStation} sec={sec} />
                </div>
                <div>
                  <SMPDFSWR activeStation={activeStation} sec={sec} />
                </div>{" "}
                <div>
                  <SMPDFPassengerAmt activeStation={activeStation} sec={sec} />
                </div>
              </div>
            </div>
            {data.station_layouts?.length > 0 && (
              <div className="shadow-sm rounded mb-4">
                <div className="card-header-soft">
                  <strong>LAYOUT</strong>
                </div>

                <div
                  className=" m-1 mb-2 p-0 glass-card"
                  style={{
                    maxHeight: "650px",
                    overflow: "auto",
                  }}
                >
                  <table className="text-start">
                    <thead>
                      <tr>
                        {head1.map((o, i) => (
                          <th key={i}>{o}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {" "}
                      {data.station_layouts?.map((o, i) => (
                        <tr>
                          <td>{i + 1}</td>
                          <td>{o.line_name}</td>
                          <td>{o.line_category}</td> <td>{o.length_mtrs}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div>
          <div className="alert alert-danger text-center" role="alert">
            <MdNearbyError /> No Data Found
          </div>
        </div>
      )}

      {/* ///////////////////2//////////////////// */}
    </div>
  );
};

export default StationDetails;
